export function LoadingSpinner({ size = 32 }: { size?: number }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 16 }}>
      <div
        style={{
          width: size,
          height: size,
          border: '3px solid #e0e0e0',
          borderTop: '3px solid #2196F3',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }}
      />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
